import { css } from 'styled-components';

export const buttonReset = css`
    appearance: none;
    margin: 0;
    padding: 0;
    border: 0;
    background: none;
    color: inherit;
    font: inherit;
    letter-spacing: inherit;
    text-transform: inherit;
    align-items: normal;

    &::-moz-focus-inner {
        border: 0;
        padding: 0;
    }
`;
